// Builds a mailto: URL that opens the user's email client pre-filled with
// the form payload. Interim solution until a proper backend (Formspree,
// Cloudflare Worker, etc.) is wired up.

export const FORWARO_INQUIRY_EMAIL = "pro@forwaro.com";

interface MailtoOptions {
  to?: string;
  subject: string;
  body: string;
}

export const buildMailtoUrl = ({
  to = FORWARO_INQUIRY_EMAIL,
  subject,
  body,
}: MailtoOptions): string => {
  const params = new URLSearchParams({ subject, body });
  return `mailto:${to}?${params.toString().replace(/\+/g, "%20")}`;
};

export const openMailto = (options: MailtoOptions): void => {
  window.location.href = buildMailtoUrl(options);
};

export const formatBody = (entries: [string, string | number | undefined][]): string => {
  return entries
    .filter(([, v]) => v !== undefined && v !== "")
    .map(([k, v]) => `${k}: ${v}`)
    .join("\n");
};
